export const ageMethod = "age nearest";
export const gateway = "https://jeminsurance-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/jeminsurance";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqZW1pbnN1cmFuY2UiLCJuYW1lIjoiamVtaW5zdXJhbmNlIiwiaWF0IjoxNzc5OTI0MjUzLCJleHAiOjE5Mzc3MTIyNTN9.85olN9f_xt5x45YKgW4OCGEFjLRVnYbqmXgZSfk1lck";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"jeminsurance.link.wawanesalife.com": {
		a: {
			approve_company: "CENTRAL",
			approve_user: "link_jeminsurance",
			brands: [
				"jeminsurance.link.wawanesalife.com",
			],
			broker: "jeminsurance",
			broker_formatted_name: "JEM Insurance",
			email: "info@jeminsurance.ca",
			environment: "stable",
			environment_id: "stable",
			formLabels: "show",
			layout: "flat",
			logoPosition: "menu",
			map1: [
				"987 Portage Avenue",
				"Winnipeg",
				"MB",
				"R3G 0R7",
			],
			map2: [
				"12-963 Henderson Hwy",
				"Winnipeg",
				"MB",
				"R2K 2M3",
			],
			map3: [
				"9-35 Lakewood Boulevard",
				"Winnipeg",
				"MB",
				"R2J 2M8",
			],
			map4: [
				"640 Central Avenue",
				"Ste Rose du Lac",
				"MB",
				"R0L 1S0",
			],
			"maps": {
				"map4": [
					"640 Central Avenue",
					"Ste Rose du Lac",
					"MB",
					"R0L 1S0",
				],
				"map3": [
					"9-35 Lakewood Boulevard",
					"Winnipeg",
					"MB",
					"R2J 2M8",
				],
				"map2": [
					"12-963 Henderson Hwy",
					"Winnipeg",
					"MB",
					"R2K 2M3",
				],
				"map1": [
					"987 Portage Avenue",
					"Winnipeg",
					"MB",
					"R3G 0R7",
				],
			},
			menuPhone: "button",
			phone: "204-774-4471",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://jeminsurance.ca/privacy-policy/",
			tagline: "We’re here to help",
			website: "https://jeminsurance.ca",
			scope: "jeminsurance#branding#jeminsurance.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "jeminsurance.link.wawanesalife.com",
		},
		b: {
			approve_company: "CENTRAL",
			approve_user: "link_jeminsurance",
			brands: [
				"jeminsurance.link.wawanesalife.com",
			],
			broker: "jeminsurance",
			broker_formatted_name: "JEM Insurance",
			email: "info@jeminsurance.ca",
			environment: "stable",
			environment_id: "stable",
			formLabels: "show",
			layout: "flat",
			logoPosition: "menu",
			map1: [
				"987 Portage Avenue",
				"Winnipeg",
				"MB",
				"R3G 0R7",
			],
			map2: [
				"12-963 Henderson Hwy",
				"Winnipeg",
				"MB",
				"R2K 2M3",
			],
			map3: [
				"9-35 Lakewood Boulevard",
				"Winnipeg",
				"MB",
				"R2J 2M8",
			],
			map4: [
				"640 Central Avenue",
				"Ste Rose du Lac",
				"MB",
				"R0L 1S0",
			],
			"maps": {
				"map4": [
					"640 Central Avenue",
					"Ste Rose du Lac",
					"MB",
					"R0L 1S0",
				],
				"map3": [
					"9-35 Lakewood Boulevard",
					"Winnipeg",
					"MB",
					"R2J 2M8",
				],
				"map2": [
					"12-963 Henderson Hwy",
					"Winnipeg",
					"MB",
					"R2K 2M3",
				],
				"map1": [
					"987 Portage Avenue",
					"Winnipeg",
					"MB",
					"R3G 0R7",
				],
			},
			menuPhone: "button",
			phone: "204-774-4471",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://jeminsurance.ca/privacy-policy/",
			tagline: "We’re here to help",
			website: "https://jeminsurance.ca",
			scope: "jeminsurance#branding#jeminsurance.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "jeminsurance.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 18:24:13 GMT-0500 (Central Daylight Time)
